import axios from "axios";

export default {
  namespaced: true,
  state: {
    requiredResourcesData: []
  },
  getters: {
    getRequiredResourcesData: state => state.requiredResourcesData?.data,
    getRequiredResourcesMeta: state => state.requiredResourcesData?.meta
  },
  mutations: {
    setRequiredResourcesData(state, data) {
      state.requiredResourcesData = data;
    }
  },
  actions: {
    getRequiredResourcesData({ commit }, payload) {
      let { page = 1, perPage = 15 } = payload;
      return new Promise(resolve => {
        axios
          .get("/required-resources", {
            params: {
              page,
              perPage
            }
          })
          .then(res => {
            commit("setRequiredResourcesData", res.data);
            resolve("done");
          });
      });
    }
  }
};
